export default {
  computed: {},
  watch: {},
  methods: {
    setLocationData(evt, model_label) {
      console.log("setLocationData evt:", evt);
      let { location, section_name } = evt ?? {};
      Object.assign(this[model_label], { location, section_name });
    },
    checkLocationError(location_data, location_section_id) {
      console.log("checkLocationError location:", location_data);
      location_data = location_data ?? {};
      const { city, address1, address2 } = location_data;
      console.log(
        "checkLocationError location_section_id:",
        location_section_id
      );
      if (!location_section_id && !city && (address1 || address2)) {
        throw new Error(this.$translate("city_is_required"));
      }
    },
    getCurrentLocation(options) {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation)
          return reject(
            "Cannot identify your location. Ensure your browser is enabled for GeoLocation!"
          );
        options = options || {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        };
        function success(pos) {
          const crd = pos.coords;

          console.log("Your current position is:");
          console.log(`Latitude : ${crd.latitude}`);
          console.log(`Longitude: ${crd.longitude}`);
          console.log(`More or less ${crd.accuracy} meters.`);
          return resolve(pos);
        }

        function error(err) {
          console.warn(`ERROR(${err.code}): ${err.message}`);
          return reject(err);
        }
        navigator.geolocation.getCurrentPosition(success, error, options);
      });
    },
    async getSignatureAddress() {
      try {
        const p = await this.getCurrentLocation();
        const lat = p.coords.latitude;
        const long = p.coords.longitude;
        const getAddress = await this.$store.dispatch("orders/geocodeStreet", {
          lat,
          long,
        });
        return {
          lat: p.coords.latitude,
          long: p.coords.longitude,
          signature_address: getAddress[0].display_name,
        };
      } catch (err) {
        console.error("getSignatureAddress ", err);
        return {
          lat: null,
          long: null,
          signature_address: null,
        };
      }
    },
  },
};
